<template>
    <div class="ui grid container">
        <div class="row">  
            <div class="three ui buttons">
                <a class="ui green button" :href="defaultUrl"><i class="left chevron icon"></i>{{ lang.say('BTN_CONTINUE_SHOPPING') }}</a>
                <button type="button" class="ui button cleanCart" v-if="inCart" @click="removeAllProducts"><i class="trash icon"></i>{{ lang.say('BTN_CLEAN_CART') }}</button>
                <button type="submit" class="ui blue button toShipping" v-if="inCart">{{ lang.say('BTN_CHECKOUT') }}<i class="right chevron icon"></i></button>
            </div>
        </div>
    </div>
</template>

<script>
    import lang from '../lang';

    export default {
        data() {
            return {
                lang
            };
        },
        props: ['in-cart', 'default-url'],
        methods: {
            removeAllProducts() {
                this.$emit('removeAllProducts');
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// ButtonCollection.vue?6adc6800